module.exports = __webpack_public_path__ + "img/hotsys_5.a69d61a9.png";